import { useState } from 'react';
import TransactionDetails from '../TransactionDetails';
import TransactionCard from './TransactionCard';
import { getTenant } from '../../../../Utils/storageUtils';
import { TenantType } from '../../../../Utils/types';
import TransactionCardOld from './TransactionCard(pb-yb)';
import jfsStyles from './index.module.css';
import otherStyles from './index-other.module.css';

const styles = getTenant() === TenantType.JFS ? jfsStyles : otherStyles;

type Props = {
  transaction: any;
  isBadge?: boolean;
  showDateOfTransaction?: boolean;
  isPendingRec?: boolean;
  isCompletedRec?: boolean;
  className?: string;
  transactionImageBGProp?: string;
  iconSize?: string;
  showTransactionDetails?: boolean;
};

const Transaction: React.FC<Props> = ({
  transaction,
  showDateOfTransaction,
  isPendingRec,
  isCompletedRec,
  className,
  transactionImageBGProp,
  iconSize,
  showTransactionDetails = false,
}) => {
  const [isDetailedTransactionSheetOpen, setIsDetailedTransactionSheetOpen] =
    useState(false);

  const handleTransactionClick = () => {
    if (getTenant() === TenantType.JFS) {
      return;
    }
    if (showTransactionDetails) {
      setIsDetailedTransactionSheetOpen(true);
    }
  };

  return (
    <>
      {isDetailedTransactionSheetOpen ? (
        <TransactionDetails
          closeSheet={() => setIsDetailedTransactionSheetOpen(false)}
          transaction={transaction}
        />
      ) : (
        <></>
      )}
      <div
        className={`${styles.transactionCard} ${className}`}
        id={transaction.id ? transaction.id : transaction.category}
        onClick={handleTransactionClick}
      >
        {getTenant() === TenantType.JFS ? (
          <TransactionCard
            iconSize={iconSize}
            transaction={transaction}
            transactionImageBGProp={transactionImageBGProp}
            isCompletedRec={isCompletedRec}
            isPendingRec={isPendingRec}
            showDateOfTransaction={showDateOfTransaction}
          />
        ) : (
          <TransactionCardOld
            iconSize={iconSize}
            transaction={transaction}
            transactionImageBGProp={transactionImageBGProp}
            isCompletedRec={isCompletedRec}
            isPendingRec={isPendingRec}
            showDateOfTransaction={showDateOfTransaction}
          />
        )}
      </div>
    </>
  );
};

export default Transaction;
